<div *ngIf="documentDetails">
    <div class="card">
        <div class="card-body">
            <div mat-dialog-title class="heading">
                Update Document Title
                <!-- <mat-divider></mat-divider> -->
            </div>

            <div class="container">
                <div class="properties-column row">
                    <span class="col-4" style="font-weight: 500;">Category: </span>
                    <span class="properties-value col-8">{{documentDetails.categoryName}}</span>
                </div>
                <div class="properties-column row">
                    <span class="col-4" style="font-weight: 500;">Title: </span>
                    <span class="properties-value col-8">{{documentDetails.documentName}}</span>
                </div>
                <div class="properties-column row">
                    <span class="col-4" style="font-weight: 500;">Document Id: </span>
                    <span class="properties-value col-8">{{documentDetails.documentId}}</span>
                </div>
                <div *ngIf=documentDetails.locked class="properties-column row">
                    <span class="col-4" style="font-weight: 500;">Locked By: </span>
                    <span class="properties-value col-8">{{documentDetails.locked_by}}</span>
                </div>
            </div>
        </div>
    </div>
    <mat-accordion displayMode="flat">
        <mat-expansion-panel open>
            <mat-expansion-panel-header [class.selected-header]="selectedHeader === 2" (click)="selectedHeader = 2"
                collapsedHeight="38px" expandedHeight="38px">
                <mat-panel-title>File Metadata</mat-panel-title>
                <mat-divider></mat-divider>
            </mat-expansion-panel-header>
            <div>
                <div *ngIf="propertyCols.length < 1">No metadata defined for this document</div>
                <mat-list-item *ngFor="let column of propertyCols">
                    <div class="properties-column" matLine> <span style="font-weight: 500">{{column}}</span>
                        <span class="properties-value">{{documentProp[column]}}</span>
                    </div>
                </mat-list-item>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <div *ngIf="!uploadMessage">
        <div class="input-group mb-3 mt-3 input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">Title</span>
            </div>
            <input id="name" name="name" [(ngModel)]="title">
        </div>

        <!-- 
    
    
                    <div class="input-group-prepend mt-3 mb-3">
                        <span class="input-group-text form-label-105">Title</span>
    
                    </div> -->
        <!-- <mat-form-field
                                class="col" appearance="standard">
                                    <mat-label>{{documentDetails.title}}</mat-label>
                                    <input matInput name="{{'name'}}"
                                        [(ngModel)]="documentDetails.title" required>
                                </mat-form-field> -->


        <button mat-raised-button class="actionButton mr-3" (click)="back()">Back</button>
        <button mat-raised-button class="actionButton mr-3" [disabled]="!title"
            (click)="updateDocumentTitle()">Update</button>
    </div>


    <div class="card" *ngIf="uploadMessage">
        <div class="card-body">

            <div>Title has been updated.</div>
            <button style="margin: 3px; float: right;" mat-raised-button (click)="back()">Back</button>

        </div>
    </div>

</div>